import DashboardComponent from '@views/dashboards/show';
import DashboardGroupComponent from '@views/dashboards/group';

export default [
  {
    path: '/dashboards/:dashboardId?',
    component: DashboardComponent,
    name: 'dashboard#show',
    meta: {
      disappearingSearchbar: true,
    },
  },
  {
    path: '/dashboard-groups/:navigationGroupId?/catalog',
    component: DashboardGroupComponent,
    name: 'dashboardGroup#catalog',
    meta: {
      disappearingSearchbar: true,
    },
  },
  {
    path: '/dashboard-groups/:navigationGroupId?/dashboard/:dashboardId?',
    component: DashboardGroupComponent,
    name: 'dashboard#group',
    meta: {
      disappearingSearchbar: true,
    },
  },
  {
    path: '/',
    name: 'mastery#home',
    component: DashboardComponent,
    meta: {
      disappearingSearchbar: true,
      resourceOptional: true,
    },
  },
];
